// extracted by mini-css-extract-plugin
module.exports = {"field":"BasicInfoForm_field__1V7y2"};